import { motion, AnimatePresence } from "motion/react"
import { useEffect, useRef, useState } from "react"

const marcas = [
    "/img/marcas/1.png",
    "/img/marcas/2.png",
    "/img/marcas/3.png",
    "/img/marcas/4.png",
    "/img/marcas/5.png",
    "/img/marcas/6.png",
    "/img/marcas/7.png",
    "/img/marcas/8.png",
    "/img/marcas/9.png",
  ]


  const MarcasCarousel = () => {
    const [index, setIndex] = useState(0)
    const intervalRef = useRef<number | null>(null)
  
    const prevIndex = (index - 1 + marcas.length) % marcas.length
    const nextIndex = (index + 1) % marcas.length
  
    const next = () => setIndex((i) => (i + 1) % marcas.length)
    const prev = () => setIndex((i) => (i - 1 + marcas.length) % marcas.length)
  
    /* AUTOPLAY */
    const startAutoPlay = () => {
      stopAutoPlay()
      intervalRef.current = window.setInterval(next, 3000)
    }
  
    const stopAutoPlay = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  
    useEffect(() => {
      startAutoPlay()
      return stopAutoPlay
    }, [])
  
    return (
      <div
        className="position-relative overflow-hidden py-5 d-flex justify-content-center align-items-center"
        style={{ perspective: "1200px", minHeight: "260px" }}
        onMouseEnter={stopAutoPlay}
        onMouseLeave={startAutoPlay}
        onTouchStart={stopAutoPlay}
        onTouchEnd={startAutoPlay}
      >
        {/* PREV */}
        <motion.img
          key={`prev-${prevIndex}`}
          src={marcas[prevIndex]}
          animate={{
            x: "-300px",
            scale: 0.85,
            rotateY: 25,
            opacity: 0.45,
            filter: "blur(3px)",
          }}
          transition={{ duration: 0.6 }}
          style={{ height: 200, position: "absolute", zIndex: 1 }}
        />
  
        {/* CENTER */}
        <AnimatePresence mode="wait">
          <motion.img
            key={index}
            src={marcas[index]}
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{
              opacity: 1,
              scale: 1,
              rotateY: 0,
              filter: "blur(0px)",
            }}
            exit={{ opacity: 0, scale: 0.85 }}
            transition={{ duration: 0.6 }}
            style={{ height: 260, zIndex: 3 }}
          />
        </AnimatePresence>
  
        {/* NEXT */}
        <motion.img
          key={`next-${nextIndex}`}
          src={marcas[nextIndex]}
          animate={{
            x: "300px",
            scale: 0.85,
            rotateY: -25,
            opacity: 0.45,
            filter: "blur(3px)",
          }}
          transition={{ duration: 0.6 }}
          style={{ height: 200, position: "absolute", zIndex: 1 }}
        />
  
      </div>
    )
  }
  
  export default MarcasCarousel